import React, { createContext, useContext, useState } from 'react';

import { STANDALONE_CART_TYPE } from '../../../../utils/consts';

const CartStandaloneContext = createContext(null);

export const CartStandaloneProvider = ({ children }) => {
      const [selectedTab, setSelectedTab] = useState(STANDALONE_CART_TYPE.INFO);
      const [client, setClient] = useState(null);
      const [standaloneCartProducts, setStandaloneCartProducts] = useState([]);
      const [discount, setDiscount] = useState(null);
      const [isStandaloneCartDetailsSideBarShown, setIsStandaloneCartDetailsSideBarShown] = useState(false);
      const [standaloneCartRecoveryUrl, setStandaloneCartRecoveryUrl] = useState('');
      const [createdSACartId, setCreatedSACartId] = useState('');

      const onChangeTab = (tab) => {
            setSelectedTab(tab)
      };

      const onChangeClient = (client) => {
            setClient(client)
      };

      const navigateToStandaloneCartTab = () => {
            onChangeTab(STANDALONE_CART_TYPE.CART);
      }

      const navigateToStandaloneClientTab = () => {
            onChangeTab(STANDALONE_CART_TYPE.INFO);
      };

      const onUpdateStandaloneCartProducts = async (updatedStandaloneCartProducts) => {
            // add new product
            if (Array.isArray(updatedStandaloneCartProducts)) {
                  setStandaloneCartProducts(updatedStandaloneCartProducts);
            }

            // update counter of product
            if (updatedStandaloneCartProducts instanceof Function) {
                  setStandaloneCartProducts( (currentProducts) => {
                        return updatedStandaloneCartProducts(currentProducts);
                  })
            }
      };

      return (
            <CartStandaloneContext.Provider
                  value={{
                        selectedTab,
                        onChangeTab,
                        client,
                        onChangeClient,
                        navigateToStandaloneCartTab,
                        navigateToStandaloneClientTab,
                        standaloneCartProducts,
                        onUpdateStandaloneCartProducts,
                        discount,
                        setDiscount,
                        setStandaloneCartProducts,
                        isStandaloneCartDetailsSideBarShown,
                        setIsStandaloneCartDetailsSideBarShown,
                        standaloneCartRecoveryUrl,
                        setStandaloneCartRecoveryUrl,
                        createdSACartId,
                        setCreatedSACartId,
                  }}
            >
                  {children}
            </CartStandaloneContext.Provider>
      )
}

export const useCartStandaloneProvider = () => {
      const context = useContext(CartStandaloneContext);
      if (!context) {
            throw new Error('useCartStandaloneProvider must be used within the CartStandaloneProvider');
      }
      return context;
}
